module.exports = __webpack_public_path__ + "img/ki.76284f07.svg";